// Staff access helpers. The owner/master account signs in with a personal
// gmail address, not an @koltprinting.com one, so every staff gate must
// honour `is_owner` or the owner gets locked out of their own back office.

const DOMAIN = "@koltprinting.com";

export const isStaff = (user) =>
  !!user && (!!user.is_owner || (user.email || "").toLowerCase().endsWith(DOMAIN));

export const isStaffOrRole = (user, roles = []) =>
  isStaff(user) || (!!user?.role && roles.includes(user.role));
